import {
    JOBBYID_CONFIRMED_ACTION,
    JOBBYID_FAILED_ACTION,
    JOBTITLE_CONFIRMED_ACTION,
    JOBTITLE_FAILED_ACTION
} from "../actions/actionTypes";


const initialState = {
    list: [],
    data: {},
    errorMessage: '',
    successMessage: '',
    showLoading: false,
};

export function JobReducer(state = initialState, action) {
    if (action.type === JOBTITLE_CONFIRMED_ACTION) {
        return {
            ...state,
            list: action.payload,
            errorMessage: '',
            successMessage: 'job titles fetched successfully',
            showLoading: false,
        };
    } else if (action.type === JOBBYID_CONFIRMED_ACTION) {
        return {
            ...state,
            data: action.payload,
            errorMessage: '',
            successMessage: 'job by id fetched successfully',
            showLoading: false,
        };
    } else if (
        action.type === JOBTITLE_FAILED_ACTION ||
        action.type === JOBBYID_FAILED_ACTION
    ) {

        return {
            ...state,
            errorMessage: action.payload,
            successMessage: '',
            showLoading: false,
        };
    } else {
        return state;
    }
}
